module.exports = __webpack_public_path__ + "assets/campaign.c4a4cb3f.svg";